import React from 'react';

interface StatusBadgeProps {
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const getStatusColor = () => {
    switch (status) {
      case 'new':
        return 'bg-blue-100 text-blue-800';
      case 'read':
        return 'bg-gray-100 text-gray-800';
      case 'reply_requested':
        return 'bg-yellow-100 text-yellow-800';
      case 'reply_sent':
        return 'bg-green-100 text-green-800';
      case 'closed':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case 'new':
        return 'New';
      case 'read':
        return 'Read';
      case 'reply_requested':
        return 'Reply Requested';
      case 'reply_sent':
        return 'Reply Sent';
      case 'closed':
        return 'Closed';
      default:
        return status;
    }
  };

  return (
    <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor()}`}>
      {getStatusLabel()}
    </span>
  );
};

export default StatusBadge;